import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { CrudService } from 'src/core/services/crud/crud.service';
import { ListResponseDto } from 'src/core/models/request/list-response.dto';
import { resolveUrl, API_PREFIX } from 'src/core/constants/api.constants';
import { CrmSegmentContactDto } from '../models/crm-segment-contact.dto';
import { UpdateCrmSegmentContactsDto } from '../models/update-crm-segment-contacts.dto';

const CRM_SEGMENT = `${API_PREFIX}/crm-segment-definition`;

@Injectable({
  providedIn: 'root',
})
export class CrmSegmentDefinitionService {
  private readonly crudService = inject(CrudService);
  private readonly http = inject(HttpClient);

  getLinkedContactCount(id: number): Observable<number> {
    return this.http.get<number>(resolveUrl(`${CRM_SEGMENT}/${id}/assigned-contact-count`));
  }

  getAssignedContactPage(
    id: number,
    skipCount: number,
    maxResultCount: number,
  ): Observable<ListResponseDto<CrmSegmentContactDto>> {
    const params = new HttpParams()
      .set('skipCount', String(skipCount))
      .set('maxResultCount', String(maxResultCount));

    return this.http.get<ListResponseDto<CrmSegmentContactDto>>(
      resolveUrl(`${CRM_SEGMENT}/${id}/assigned-contact-page`),
      { params },
    );
  }

  getAssignableContacts(
    id: number,
    filter: string,
    skipCount: number,
    maxResultCount: number,
  ): Observable<ListResponseDto<CrmSegmentContactDto>> {
    let params = new HttpParams()
      .set('skipCount', String(skipCount))
      .set('maxResultCount', String(maxResultCount));
    if (filter) {
      params = params.set('filter', filter);
    }

    return this.http.get<ListResponseDto<CrmSegmentContactDto>>(
      resolveUrl(`${CRM_SEGMENT}/${id}/assignable-contacts`),
      { params },
    );
  }

  updateContacts(id: number, input: UpdateCrmSegmentContactsDto): Observable<void> {
    return this.http.put<void>(resolveUrl(`${CRM_SEGMENT}/${id}/contacts`), input);
  }

  checkNameUnique(name: string, excludedId?: number): Observable<boolean> {
    let params = new HttpParams().set('name', name);
    if (excludedId != null) {
      params = params.set('excludedId', String(excludedId));
    }

    return this.http
      .get<
        boolean | { isUnique?: boolean; data?: boolean }
      >(resolveUrl(`${CRM_SEGMENT}/check-name-unique`), { params })
      .pipe(
        map(response => {
          if (typeof response === 'boolean') {
            return response;
          }

          if (typeof response?.isUnique === 'boolean') {
            return response.isUnique;
          }

          if (typeof response?.data === 'boolean') {
            return response.data;
          }

          return false;
        }),
      );
  }
}
